import React, { useState, useEffect } from "react";
import "./MD.css";
import Navbar from "../../Navbar/Navbar"; // adjust this path to match your actual folder structure

const LIST_FILES_API_URL = "https://lfsofficial.in/api/admin_list_files.php";

const disclosureData = [
  {
    section: "1. General Information",
    items: [
      { label: "Name of the School", value: "Little Flowers' School" },
      { label: "Affiliation No.", value: "153047" },
      { label: "School Code", value: "NA" },
      { label: "Complete Address", value: "Rairangpur, Mayurbhanj, Odisha - 757043" },
      { label: "Principal Name", value: "Mr. kaliprasanna Mohanty" },
      { label: "Principal Qualification", value: "M.A., B.Ed." },
      { label: "School Email", value: "lfsrkrrpmbj@gmail.com" },
      { label: "Contact No.", value: "+91 76550 22486" },
    ],
  },
  {
    section: "2. Documents & Certificates",
    items: [
      { label: "Copies of Affiliation/Upgradation Letter", value: "Available" },
      { label: "Copies of Societies/Trust Deed", value: "Available" },
      { label: "Copy of No Objection Certificate (NOC)", value: "Available" },
      { label: "Copy of Recognition Certificate", value: "Available" },
      { label: "Copy of Valid Building Safety Certificate", value: "Available" },
      { label: "Copy of Valid Fire Safety Certificate", value: "Available" },
      { label: "Copy of DEO Certificate", value: "Available" },
      { label: "Copies of Valid Water & Health Sanitation Certificates", value: "Available" },
    ],
  },
  {
    section: "3. Result & Academics",
    items: [
      { label: "Fee Structure of the School", value: "As per CBSE Guidelines" },
      { label: "Annual Academic Calendar", value: "April to March" },
      { label: "List of School Management Committee (SMC)", value: "Available on Notice Board" },
      { label: "List of Parents Teachers Association (PTA)", value: "Available on Notice Board" },
      { label: "Last 3 Years Result of Board Examination", value: "2022: 97% | 2023: 98% | 2024: 99%" },
    ],
  },
  {
    section: "4. Staff Details",
    items: [
      { label: "Principal", value: "1" },
      { label: "Total No. of Teachers", value: "48" },
      { label: "PGT Teachers", value: "18" },
      { label: "TGT Teachers", value: "20" },
      { label: "PRT Teachers", value: "10" },
      { label: "Teachers Section Ratio", value: "1:1.5" },
      { label: "Details of Special Educator", value: "1" },
      { label: "Details of Counsellor & Wellness Teacher", value: "1" },
    ],
  },
  {
    section: "5. School Infrastructure",
    items: [
      { label: "Total Campus Area (in sq. mtr)", value: "5000 sq. mtr" },
      { label: "No. of Building Blocks", value: "3" },
      { label: "Total No. of Classrooms", value: "25" },
      { label: "No. of Girls Toilets", value: "4" },
      { label: "No. of Boys Toilets", value: "4" },
      { label: "Library", value: "Yes" },
      { label: "Smart Classrooms", value: "Yes" },
      { label: "Playground", value: "Yes" },
      { label: "Swimming Pool", value: "No" },
      { label: "Indoor Games", value: "Yes" },
      { label: "Dance Rooms", value: "Yes" },
      { label: "Gymnasium", value: "No" },
      { label: "Music Rooms", value: "Yes" },
      { label: "Hostels", value: "yes" },
      { label: "Health & Medical Check-up", value: "Yes" },
    ],
  },
];

const Mandetorydisclosure = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filesLoading, setFilesLoading] = useState(true);
  const [filesError, setFilesError] = useState("");

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await fetch(LIST_FILES_API_URL);
        const data = await response.json();

        if (data.success) {
          setUploadedFiles(data.files);
        } else {
          setFilesError("Could not load uploaded documents.");
        }
      } catch (err) {
        setFilesError(`Unable to reach the server: ${err.message}`);
      } finally {
        setFilesLoading(false);
      }
    };

    fetchFiles();
  }, []);

  return (
    <>
      <Navbar />
      <div className="md-page">
        {/* HERO */}
        <section className="md-hero">
        <div className="md-hero__bg" />
        <div className="md-hero__content">
          <span className="md-eyebrow">Transparency & Compliance</span>
          <h1>Mandatory Disclosure</h1>
          <p>
            As per CBSE affiliation bye-laws, all mandatory information about
            Little Flowers' School is disclosed here for parents, students and the public.
          </p>
          <div className="md-hero__pills">
            <span className="md-pill">📋 CBSE Compliant</span>
            <span className="md-pill">🏫 Aff. No. 1530232</span>
            <span className="md-pill">📅 Updated 2024–25</span>
          </div>
        </div>
      </section>

      {/* DISCLOSURE SECTIONS */}
      <section className="md-content">
        {disclosureData.map((block) => (
          <div className="md-block" key={block.section}>
            <h2 className="md-block__title">{block.section}</h2>
            <div className="md-table">
              {block.items.map((item, i) => (
                <div className="md-row" key={i}>
                  <div className="md-row__label">{item.label}</div>
                  <div className="md-row__value">{item.value}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>

      {/* DOWNLOAD SECTION */}
      <section className="md-downloads">
        <h2>Download Documents</h2>
        <p>The following documents are available for download as per CBSE requirements.</p>
        <div className="md-downloads__grid">
          {[
            { icon: "📄", name: "Affiliation Letter", size: "1.2 MB" },
            { icon: "📄", name: "NOC Certificate", size: "0.8 MB" },
            { icon: "📄", name: "Building Safety Certificate", size: "1.1 MB" },
            { icon: "📄", name: "Fire Safety Certificate", size: "0.9 MB" },
            { icon: "📄", name: "DEO Certificate", size: "0.7 MB" },
            { icon: "📄", name: "Fee Structure 2024–25", size: "0.5 MB" },
          ].map((doc) => {
            // Match this card to the most recently uploaded file with the same category.
            // "Fee Structure 2024–25" matches the "Fee Structure" category loosely.
            const matchedFile = uploadedFiles.find((f) =>
              doc.name.startsWith(f.category)
            );

            return (
              <div className="md-doc-card" key={doc.name}>
                <span className="md-doc-card__icon">{doc.icon}</span>
                <div className="md-doc-card__info">
                  <strong>{doc.name}</strong>
                  <span>{matchedFile ? matchedFile.filename : doc.size}</span>
                </div>
                {matchedFile ? (
                  <a
                    href={matchedFile.filepath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="md-doc-card__btn"
                    style={{ textDecoration: "none", textAlign: "center" }}
                  >
                    ⬇ Download
                  </a>
                ) : (
                  <button className="md-doc-card__btn" disabled style={{ opacity: 0.5, cursor: "not-allowed" }}>
                    ⬇ Not uploaded yet
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* UPLOADED DOCUMENTS (from Admin Panel) */}
      <section className="md-downloads">
        <h2>Uploaded Documents</h2>
        <p>Recently uploaded files from the school administration.</p>

        {filesLoading && <p className="md-status">Loading uploaded documents...</p>}
        {filesError && <p className="md-error">{filesError}</p>}

        {!filesLoading && !filesError && uploadedFiles.length === 0 && (
          <p className="md-status">No documents uploaded yet.</p>
        )}

        {!filesLoading && !filesError && uploadedFiles.length > 0 && (
          <div className="md-downloads__grid">
            {uploadedFiles.map((file, index) => (
              <div className="md-doc-card" key={index}>
                <span className="md-doc-card__icon">📄</span>
                <div className="md-doc-card__info">
                  <strong>{file.filename}</strong>
                  <span>
                    {new Date(file.uploaded_at).toLocaleDateString()}
                  </span>
                </div>
                <a
                  href={file.filepath}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="md-doc-card__btn"
                  style={{ textDecoration: "none", textAlign: "center" }}
                >
                  ⬇ Download
                </a>
              </div>
            ))}
          </div>
        )}
      </section>
      </div>
    </>
  );
};

export default Mandetorydisclosure;